import { useGetPositiveNumberRule, useGetRequiredRule, useLengthValidationRule } from '@/hooks';
import { useTranslation } from 'react-i18next';
import { PricesFormValues } from '../helpers';

export const usePhotoShootingFormRules = () => {
  const { t } = useTranslation(['validations']);

  const requiredRule = useGetRequiredRule({ t });
  const positiveOnly = useGetPositiveNumberRule({ t });
  const lengthRule = useLengthValidationRule({ t, max: 500 });

  return {
    [PricesFormValues.DESCRIPTION_EN]: [requiredRule, lengthRule],
    [PricesFormValues.DESCRIPTION_NO]: [requiredRule, lengthRule],
    [PricesFormValues.PROPERTY_TYPE]: [requiredRule],
    [PricesFormValues.NAME_EN]: [requiredRule],
    [PricesFormValues.NAME_NO]: [requiredRule],
    [PricesFormValues.PRICE]: [requiredRule],
    [PricesFormValues.FROM]: [positiveOnly],
    [PricesFormValues.TO]: [positiveOnly],
  };
};

export const useSettlementFormRules = () => {
  const { t } = useTranslation(['validations']);

  const requiredRule = useGetRequiredRule({ t });
  const lengthRule = useLengthValidationRule({ t, max: 500 });

  return {
    [PricesFormValues.DESCRIPTION_EN]: [requiredRule, lengthRule],
    [PricesFormValues.DESCRIPTION_NO]: [requiredRule, lengthRule],
    [PricesFormValues.NAME_EN]: [requiredRule],
    [PricesFormValues.NAME_NO]: [requiredRule],
  };
};
